module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAVklEQVQYV12N2w2AIBAEZy0MYzuGwnz2AO2INYhRvIje32Zm95QDMw29HInqlAMZSAivlsmYAcuLtf/gEkr7marnt7v1AWLkwKtjN1Asx/o+jwxm1XsnF0smM5JdHokAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/jiantou1.png
// module id = m4qc
// module chunks = 1